/*
 * Bed Stü custom JavaScript for Palo Alto 9.2.
 * Every feature is a module registered with BS.register(name, init). A module only
 * runs when its switch in window.theme.bedstu (Theme settings → Bed Stü customizations)
 * is on. Keep everything inside this IIFE.
 */
(function () {
  'use strict';

  var cfg = (window.theme && window.theme.bedstu) || {};
  var BS = {
    cfg: cfg,
    modules: [],
    register: function (name, enabled, init) {
      this.modules.push({ name: name, enabled: enabled, init: init });
    },
    on: function (name, handler, opts) {
      document.addEventListener(name, handler, opts || false);
    },
    debounce: function (fn, ms) {
      var t;
      return function () {
        var args = arguments, self = this;
        clearTimeout(t);
        t = setTimeout(function () { fn.apply(self, args); }, ms);
      };
    },
    // Watches the whole document for added *or removed* nodes and calls fn (debounced).
    // Used by modules that must re-apply after the theme re-renders sections via fetch.
    // 9.2 morphs the re-rendered markup in, which shows up as removals of the nodes we
    // injected with no additions of our own - added-only would never fire again.
    // fn must be idempotent: our own inserts/removals re-trigger the observer once,
    // and the debounce plus the no-op guards in each sync let it settle.
    onDomChange: function (fn, ms) {
      var run = this.debounce(fn, ms || 60);
      var mo = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var m = mutations[i];
          if ((m.addedNodes && m.addedNodes.length) ||
              (m.removedNodes && m.removedNodes.length)) { run(); return; }
        }
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });
      return mo;
    },
    money: function (text) {
      // "$1,234.56 USD" -> 1234.56 ; tolerant of currency symbols/codes
      var cleaned = String(text || '').replace(/[^0-9.,]/g, '').replace(/,/g, '');
      var n = parseFloat(cleaned);
      return isNaN(n) ? 0 : n;
    }
  };
  // Kept for callers that still use the original name.
  BS.onDomAdded = BS.onDomChange;

  /* BEDSTU START: modules */

  /* BEDSTU START: pdp */
  BS.register('pdp', true, function (BS) {
    var cfg = BS.cfg;
    var form = document.querySelector('.product-single__wrapper, [data-product-form], product-form');
    if (!form && !document.querySelector('[data-variant-buttons]')) return;

    // Resolve the <label> that carries data-swatch for a checked swatch input without
    // building a querySelector out of the (unescaped) input id.
    function labelFor(input) {
      var wrap = input && input.closest('[data-swatches-button], .swatch__button, .radio__button');
      return wrap ? wrap.querySelector('.swatch__label, .radio__label') : null;
    }

    // 1) If the checked option value is hidden (archived), select the first visible one.
    //    9.2 re-renders [data-variant-buttons] server-side on every change, so this runs
    //    after each re-render as well as on load.
    function reselectHidden(root) {
      if (!cfg.hideArchived) return;
      var groups = (root || document).querySelectorAll('[data-variant-buttons]');
      groups.forEach(function (group) {
        var checked = group.querySelector('input[data-single-option-selector]:checked');
        if (!checked) return;
        var wrapper = checked.closest('.radio__button, .swatch__button');
        if (!wrapper || !wrapper.classList.contains('bs-hidden')) return;
        var candidates = group.querySelectorAll('input[data-single-option-selector]');
        for (var i = 0; i < candidates.length; i++) {
          var w = candidates[i].closest('.radio__button, .swatch__button');
          if (w && !w.classList.contains('bs-hidden')) { candidates[i].click(); return; }
        }
      });
    }

    // 1b) A color that doesn't come in the selected size (Protege: Teak has no 7) leaves
    //     no variant, so the photos, price and button stay on the old color ("Unavailable").
    //     Pick the first in-stock size of the new color instead. Only acts when 9.2's
    //     data-selected-variant script is empty, so it never overrides a real choice.
    function reselectMissing() {
      document.querySelectorAll('variant-selects').forEach(function (vs) {
        var sel = (vs.closest('product-info') || vs).querySelector('script[data-selected-variant]');
        if (!sel || sel.textContent.trim() !== '') return;
        var groups = vs.querySelectorAll('[data-variant-buttons]');
        for (var g = groups.length - 1; g >= 0; g--) {
          if (groups[g].querySelector('input.swatch__input')) continue;
          var inputs = groups[g].querySelectorAll('input[data-single-option-selector]');
          for (var i = 0; i < inputs.length; i++) {
            var w = inputs[i].closest('.radio__button, .swatch__button');
            if (w && !w.classList.contains('sold-out') && !w.classList.contains('bs-hidden')) {
              if (!inputs[i].checked) inputs[i].click();
              return;
            }
          }
        }
      });
    }

    // 2) Klaviyo "Notify me" hiding for flagged variants.
    function syncNotifyMe() {
      if (!cfg.hideNotifyMe) return;
      var bis = document.querySelectorAll('.klaviyo-bis-trigger');
      if (!bis.length) return;
      var hide = false;
      document.querySelectorAll('[data-variant-buttons] input[data-single-option-selector]:checked').forEach(function (input) {
        var w = input.closest('[data-bs-hide-notify="true"]');
        if (w) hide = true;
      });
      bis.forEach(function (el) { el.classList.toggle('hide-this', hide); });
    }

    // 3) "Learn more about Lux finishes" link under the swatch row whenever the SELECTED
    //    colour is a Lux finish - any product, not just belts. 5.7 (snippets/hide-archived-
    //    sizes.liquid) showed it on every product whose clicked swatch name contained "lux";
    //    the 9.2 port gated it on isBeltProduct, which silently dropped it from footwear.
    function syncLuxLink() {
      if (!cfg.luxLink) return;
      var swatchWrapper = document.querySelector('.product__selectors .selector-wrapper--swatches, .product__form .selector-wrapper--swatches');
      if (!swatchWrapper) return;
      var checked = swatchWrapper.querySelector('input.swatch__input:checked');
      var label = labelFor(checked);
      var name = (label && label.getAttribute('data-swatch')) || '';
      var isLux = /lux/i.test(name);
      var existing = document.querySelector('.bs-lux-link');
      if (isLux && !existing) {
        swatchWrapper.insertAdjacentHTML('afterend',
          '<p class="shop-pay-terms bs-lux-link"><a href="' + cfg.luxLinkUrl + '">Learn more about Lux finishes</a></p>');
      } else if (!isLux && existing) {
        existing.remove();
      }
    }

    // 4) Mobile-only colour name under the swatch legend. 9.2's swatches-component only
    //    reads [data-swatches-label] (state key + height math) and never writes the
    //    selected value into it, so the 5.7 ".the-mobile-label" behaviour is still needed.
    function syncMobileLabel() {
      var wrappers = document.querySelectorAll('.selector-wrapper--swatches');
      wrappers.forEach(function (wrapper) {
        var legend = wrapper.querySelector('.radio__legend');
        if (!legend) return;
        var checked = wrapper.querySelector('input.swatch__input:checked');
        var label = labelFor(checked);
        var name = (label && label.getAttribute('data-swatch')) || '';
        var el = wrapper.querySelector('.bs-mobile-label');
        if (!el) {
          if (!name) return;
          el = document.createElement('span');
          el.className = 'bs-mobile-label';
          legend.insertAdjacentElement('afterend', el);
        }
        // Guard the write so the MutationObserver in onDomAdded cannot loop.
        if (el.textContent !== name) el.textContent = name;
      });
    }

    function runAll() { reselectHidden(); reselectMissing(); syncNotifyMe(); syncLuxLink(); syncMobileLabel(); }

    // A colour change makes 9.2 re-fetch the option markup and morph it in ~1.2-1.5s
    // later, which wipes .bs-lux-link / .bs-mobile-label. Re-run across that window
    // instead of relying on a single post-change pass. Timers are reset on every
    // change so rapid clicking does not stack them up.
    var reruns = [];
    function scheduleReruns() {
      reruns.forEach(clearTimeout);
      reruns = [300, 1200, 2000, 3500].map(function (ms) { return setTimeout(runAll, ms); });
    }

    runAll();
    window.addEventListener('load', runAll);
    BS.on('theme:variant:prices-updated', function () { runAll(); scheduleReruns(); });
    BS.on('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('input[data-single-option-selector]')) {
        setTimeout(runAll, 0);
        scheduleReruns();
      }
    });
    // product-info.js swaps the option markup after a fetch; catch that. The morph
    // shows up as removals, so this watches for added *and* removed nodes.
    BS.onDomChange(runAll, 80);
  });
  /* BEDSTU END: pdp */

  /* BEDSTU START: collection */
  BS.register('collection', true, function (BS) {
    var cfg = BS.cfg;

    // Size / color filter -> hide cards that do not have the selected value IN STOCK.
    //
    // Shopify's variant filters return every product that has a variant with the value, sold out
    // or not, and swap the card image to that variant (product.featured_media follows the
    // filter-matched variant "regardless of its availability" per the Liquid docs). Neither can be
    // changed server-side, so product-grid-item.liquid (`grid-attrs` fence) emits:
    //   - data-instock-sizes: '|'-delimited size values with an in-stock, non-archived variant,
    //     exact-matched against filter.v.option.size (port of 5.7 custom.js 322-369);
    //   - data-matched-instock: "true"/"false" = does any variant Shopify marked `matched` for the
    //     active filters have stock. Needed because filter values can be Search & Discovery /
    //     taxonomy groups ("Black" covers "Black Lux", "Black Rustic", ...). "" = unsupported.
    // Color handling added Sep 2026 after the client reported sold-out colors under the color filter.
    var SIZE_OPTION_NAMES = ['size'];
    // Any VARIANT-level filter: option (filter.v.option.*), variant metafield (filter.v.m.*) or
    // taxonomy attribute (filter.v.t.*, e.g. filter.v.t.shopify.color-pattern - this store's
    // Color filter). Price / availability filters are excluded on purpose.
    var VARIANT_FILTER_PREFIXES = ['filter.v.option.', 'filter.v.m.', 'filter.v.t.'];
    function activeValues(names) {
      var params = new URLSearchParams(window.location.search), out = [];
      names.forEach(function (name) {
        params.getAll('filter.v.option.' + name).forEach(function (v) { if (v) out.push(v); });
      });
      return out;
    }
    function variantFilterActive() {
      var params = new URLSearchParams(window.location.search), active = false;
      params.forEach(function (v, k) {
        if (!v) return;
        VARIANT_FILTER_PREFIXES.forEach(function (p) { if (k.indexOf(p) === 0) active = true; });
      });
      return active;
    }
    function hasAny(have, wanted) {
      return wanted.some(function (v) { return have.indexOf('|' + v + '|') !== -1; });
    }
    function applyFilterHiding() {
      if (!cfg.sizeFilterCards && !cfg.colorFilterCards) return;
      var sizes = cfg.sizeFilterCards ? activeValues(SIZE_OPTION_NAMES) : [];
      var variantFilter = cfg.colorFilterCards && variantFilterActive();
      document.querySelectorAll('[data-product-block][data-instock-sizes]').forEach(function (card) {
        var hideSize = false, hideColor = false;
        if (sizes.length) {
          hideSize = !hasAny(card.getAttribute('data-instock-sizes') || '', sizes);
        }
        if (variantFilter) {
          hideColor = card.getAttribute('data-matched-instock') === 'false';
        }
        card.classList.toggle('size-filter-hidden', hideSize);
        card.classList.toggle('color-filter-hidden', hideColor);
      });
    }

    if ((cfg.sizeFilterCards || cfg.colorFilterCards) && document.querySelector('[data-product-block]')) {
      applyFilterHiding();
      window.addEventListener('popstate', applyFilterHiding);
      BS.on('theme:filter:range-update', applyFilterHiding);
      BS.onDomAdded(applyFilterHiding, 60);
    }
  });
  /* BEDSTU END: collection */

  /* BEDSTU START: filter-image */
  // Keep the FILTERED featured image on the card.
  //
  // With a colour filter active the server renders each card with a matched, in-stock variant's
  // photo (see the `grid-attrs` fence in product-grid-item.liquid, which also emits
  // data-featured-src). On a full page load the theme's <deferred-loading> element then injects
  // its per-variant <template> images and marks the DEFAULT colour featured-visible, so a filtered
  // URL reverts to e.g. Gailee tan rustic under the Black filter. The AJAX filter path does not hit
  // this, which is why clicking a swatch looks right but reloading does not.
  //
  // Fix: put the server-rendered src back on whichever element the theme left visible. Compares by
  // path so CDN width/query differences do not matter; no-op on unfiltered pages. Registered before
  // hoverSync so the hover image follows the restored featured image.
  BS.register('filterImage', true, function (BS) {
    var cfg = BS.cfg;
    if (!cfg.colorFilterCards) return;

    var VARIANT_FILTER_PREFIXES = ['filter.v.option.', 'filter.v.m.', 'filter.v.t.'];
    var VISIBLE = '.product-media__img--featured-visible, .product__media--featured-visible';

    function filterActive() {
      var params = new URLSearchParams(window.location.search), active = false;
      params.forEach(function (v, k) {
        if (!v) return;
        VARIANT_FILTER_PREFIXES.forEach(function (p) { if (k.indexOf(p) === 0) active = true; });
      });
      return active;
    }
    function pathOf(url) { return (url || '').split('?')[0].replace(/^https?:/, ''); }

    function restoreFeatured() {
      if (!filterActive()) return;
      document.querySelectorAll('[data-product-block][data-featured-src]').forEach(function (card) {
        var want = card.getAttribute('data-featured-src');
        if (!want) return;
        var visible = card.querySelector(VISIBLE);
        if (!visible) return;
        var img = visible.matches('img') ? visible : visible.querySelector('img');
        if (!img) return;
        if (pathOf(img.getAttribute('src')) !== pathOf(want)) {
          img.setAttribute('src', want);
          img.setAttribute('srcset', ''); // drop the stale srcset so the new src is used
        }
      });
    }

    if (!document.querySelector('[data-product-block]')) return;
    restoreFeatured();
    window.addEventListener('load', function () {
      restoreFeatured();
      setTimeout(restoreFeatured, 300);
      setTimeout(restoreFeatured, 900);
    });
    window.addEventListener('popstate', restoreFeatured);
    BS.on('theme:filter:range-update', restoreFeatured);
    BS.onDomAdded(restoreFeatured, 60);
  });
  /* BEDSTU END: filter-image */

  /* BEDSTU START: hover-sync */
  // Keep a product card's HOVER image on the colour the card is actually showing.
  //
  // 9.2 renders the hover as a <hover-images> Flickity slider fed by `product.media limit:
  // settings.image_hover_limit` (snippets/product-grid-item.liquid:463-491) - i.e. always the
  // DEFAULT colour's photos, no matter which colour the featured image was swapped to. On a
  // colour collection (/collections/teak-oats) the card shows the teak photo but hovers to a
  // tan/icicle one; the same happens the moment a shopper hovers a swatch, because the vendor
  // GridSwatch (assets/theme.dev.js:10214 replaceImages) only cross-fades the FEATURED image
  // from its deferred <template> and never touches the hover slider.
  //
  // Fix (mirrors 5.7 assets/custom.js:372-464): every swatch carries
  // `data-swatch-hover-image` - the media right after that variant's featured image, emitted by
  // our `grid-swatch-attrs` fence - so point the hover slider's first visible frame at it and
  // hide the rest, which reproduces 5.7's single hover image.
  //
  // Which frame is visible: on desktop (.no-touch) theme.css:14335 hides the first slide while
  // the slider is not Flickity-enabled, and theme.css:14917 hides it once it IS - either way the
  // visible frame is the first `[data-hover-slide]` cell, so that is the one we repaint.
  BS.register('hoverSync', true, function (BS) {
    var cfg = BS.cfg;
    var colorName = String(cfg.collectionColorName || '').trim();
    // The colour-collection featured-image swap (5.7 snippets/select-collection-color.liquid)
    // lives here now rather than in a snippet <script>, so one observer drives both halves.
    var swapOn = !!(cfg.colorCollectionSwap && colorName);
    var needle = colorName.replace(/["\\]/g, '\\$&');

    // Compare by file path only: //cdn/...foo.jpg?v=1&width=600 vs https://cdn/...foo.jpg
    function pathOf(u) { return String(u || '').split('?')[0].replace(/^https?:/, ''); }

    function setImage(host, src) {
      if (!host) return;
      var img = host.querySelector('img');
      if (img) {
        if (pathOf(img.getAttribute('src')) === pathOf(src)) return;
        img.setAttribute('src', src);
        // A stale srcset/sizes would win over the new src on the next layout pass.
        img.removeAttribute('srcset');
        img.removeAttribute('data-srcset');
        img.removeAttribute('sizes');
        return;
      }
      // image-fill can fall back to a background-image element (placeholder / bg variant).
      var bgHost = host.querySelector('[style*="background-image"]') || host;
      var current = bgHost.style ? bgHost.style.backgroundImage || '' : '';
      if (current.indexOf(pathOf(src)) !== -1) return;
      if (bgHost.style) bgHost.style.backgroundImage = 'url(' + src + ')';
    }

    function hoverSrcOf(el) {
      if (!el) return '';
      var btn = el.getAttribute && el.getAttribute('data-swatch-hover-image')
        ? el
        : (el.closest ? el.closest('[data-swatch-button]') : null);
      return (btn && btn.getAttribute('data-swatch-hover-image')) || '';
    }

    // syncCardHover(card, swatchLabelEl): repoint this card's hover frame at the swatch's
    // colour. No-op when the swatch has no hover image (single-image colour) - better to keep
    // the theme's own hover than to blank it.
    function syncCardHover(card, swatchLabelEl) {
      if (!card) return;
      var src = hoverSrcOf(swatchLabelEl);
      if (!src) return;
      var slider = card.querySelector('[data-hover-slider]');
      if (!slider) return;
      var slides = slider.querySelectorAll('.product-media__slide');
      if (!slides.length) return;
      var target = slider.querySelector('.product-media__slide[data-hover-slide]') || slides[0];
      setImage(target, src);
      for (var i = 0; i < slides.length; i++) {
        if (slides[i] !== target) slides[i].classList.add('bs-hidden');
      }
      // Flickity was already built with every cell, so its arrows would page to a hidden
      // (blank) frame. `bs-hover-synced` hides them - custom.css `hover-sync` block.
      var hoverEl = slider.closest('hover-images') || slider.parentNode;
      if (hoverEl && hoverEl.classList) hoverEl.classList.add('bs-hover-synced');
    }

    function featuredImage(card) {
      return card.querySelector('[data-product-media-featured] .product-media__img--featured-visible img')
        || card.querySelector('[data-product-media-featured] img')
        || card.querySelector('.product-media__image img');
    }

    // Colour collections: swap each card's featured image (and hover) to the swatch whose
    // variant.metafields.custom.collection_target contains the collection's colour name.
    // Runs ONCE per card (data-bs-color-applied): after that the shopper owns the card, and
    // re-applying would undo a swatch they picked.
    function applyColorCollection() {
      if (!swapOn) return;
      document.querySelectorAll('[data-product-block]').forEach(function (card) {
        if (card.hasAttribute('data-bs-color-applied')) return;
        var swatch = card.querySelector('[data-swatch-button][data-collection*="' + needle + '" i] .swatch__label[data-swatch-image]');
        if (!swatch) return;
        var src = swatch.getAttribute('data-swatch-image');
        if (!src) return;
        var img = featuredImage(card);
        if (img) {
          if (pathOf(img.getAttribute('src')) !== pathOf(src)) {
            img.setAttribute('src', src);
            img.removeAttribute('srcset');
          }
        } else {
          var bg = card.querySelector('[data-product-media-featured] .product-media__img--featured-visible');
          if (!bg) return;
          bg.style.backgroundImage = 'url(' + src + ')';
        }
        syncCardHover(card, swatch);
        card.setAttribute('data-bs-color-applied', '1');
      });
    }

    // Every page load: the card's featured image may already be a colour other than the one
    // the hover slider was built from - the colour collection swap above, a `?variant=` deep
    // link, or simply a product whose first colour is not the one 9.2 fed the slider. 5.7 did
    // this on load for every card (old/assets/custom.js:393-433): work out WHICH swatch the
    // featured image belongs to by comparing image paths, then point the hover at that
    // swatch's hover image. Idempotent - syncCardHover/setImage no-op when already correct,
    // and re-running after a shopper picks a swatch resolves to that same swatch, because the
    // vendor has by then replaced the featured image with the one they chose.
    function syncOnLoad(root) {
      var cards = (root && root.querySelectorAll ? root : document)
        .querySelectorAll('[data-product-block]');
      for (var c = 0; c < cards.length; c++) {
        var card = cards[c];
        var swatches = card.querySelectorAll('[data-swatch-button] .swatch__label[data-swatch-image]');
        if (!swatches.length) continue; // single-colour card: nothing to reconcile
        var match = null;
        var img = featuredImage(card);
        var featuredPath = img ? pathOf(img.getAttribute('src')) : '';
        if (featuredPath) {
          for (var i = 0; i < swatches.length; i++) {
            if (pathOf(swatches[i].getAttribute('data-swatch-image')) === featuredPath) {
              match = swatches[i];
              break;
            }
          }
        }
        // One swatch = one colour, so the featured image can only be that colour even when the
        // paths differ (the grid renders a resized/cropped variant of the same photo).
        if (!match && swatches.length === 1) match = swatches[0];
        if (match) syncCardHover(card, match);
      }
    }

    // Any collection: follow the swatch the shopper is pointing at / has clicked.
    // mouseenter does not bubble, so delegate on mouseover; capture phase so a component
    // that stops propagation cannot hide the event from us.
    function onSwatchPointer(event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var button = target.closest('[data-swatch-button]');
      if (!button) return;
      var card = button.closest('[data-product-block]');
      if (!card) return;
      syncCardHover(card, button.querySelector('.swatch__label') || button);
    }

    if (!document.querySelector('[data-product-block]')) return;

    document.addEventListener('mouseover', onSwatchPointer, true);
    document.addEventListener('click', onSwatchPointer, true);

    // Colour swap first (it moves the featured image), then reconcile every card's hover.
    function pass() {
      applyColorCollection();
      syncOnLoad();
    }

    pass();
    window.addEventListener('load', function () {
      pass();
      // 9.2 lazy-loads grid images and Flickity builds the hover slider after `load`, so the
      // featured src can still change under us - 5.7 retried on the same schedule.
      setTimeout(pass, 300);
      setTimeout(pass, 900);
    });
    window.addEventListener('popstate', pass);
    // AJAX filtering / sorting re-renders the grid with fresh cards.
    BS.onDomAdded(pass, 60);
  });
  /* BEDSTU END: hover-sync */

  /* BEDSTU START: cart */
  BS.register('cart', true, function (BS) {
    var cfg = BS.cfg;
    if (!cfg.signatureGate) return;
    var threshold = parseFloat(cfg.signatureThreshold) || 749.99;

    function cartTotal() {
      var el = document.querySelector('[data-cart-total-price]');
      if (el && el.textContent.trim()) return BS.money(el.textContent);
      // /cart page: snippets/cart-price.liquid renders <span data-cart-total="{{ subtotal }}">
      // (cents in the attribute, formatted money in the text) instead of [data-cart-total-price].
      var el2 = document.querySelector('[data-cart-total]');
      if (el2) {
        var cents = parseFloat(el2.getAttribute('data-cart-total'));
        if (!isNaN(cents)) return cents / 100;
        if (el2.textContent.trim()) return BS.money(el2.textContent);
      }
      if (window.theme && typeof window.theme.subtotal === 'number') return window.theme.subtotal / 100;
      return 0;
    }
    function gates() { return document.querySelectorAll('[data-bs-signature-gate]'); }
    function needsAck() { return cartTotal() > threshold; }

    function sync() {
      var show = needsAck();
      gates().forEach(function (g) {
        g.hidden = !show;
        if (!show) {
          var w = g.querySelector('[data-bs-signature-warning]');
          if (w) w.hidden = true;
        }
      });
    }
    function acknowledged(gate) {
      var box = gate.querySelector('[data-bs-signature-checkbox]');
      return !!(box && box.checked);
    }
    function block(e, gate) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var w = gate.querySelector('[data-bs-signature-warning]');
      if (w) { w.hidden = false; w.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }
    }
    function guard(e) {
      if (!needsAck()) return;
      var btn = e.target && e.target.closest ? e.target.closest('button.cart__checkout, [name="checkout"]') : null;
      var form = e.type === 'submit' ? e.target : null;
      if (!btn && !form) return;
      var scope = (btn || form).closest('.cart__foot-inner, .cart__buttons-wrapper, [data-cart-form], .cart__foot, form') || document;
      var gate = scope.querySelector('[data-bs-signature-gate]') || document.querySelector('[data-bs-signature-gate]:not([hidden])');
      if (!gate || gate.hidden) return;
      if (!acknowledged(gate)) block(e, gate);
    }

    // Capture phase so we run before the theme's own click/submit handlers.
    document.addEventListener('click', guard, true);
    document.addEventListener('submit', guard, true);
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-bs-signature-checkbox]')) {
        var w = e.target.closest('[data-bs-signature-gate]').querySelector('[data-bs-signature-warning]');
        if (w && e.target.checked) w.hidden = true;
      }
    });

    sync();
    ['theme:cart:loaded', 'theme:cart:open', 'theme:cart:added', 'theme:cart:update', 'theme:cart:refresh'].forEach(function (n) {
      BS.on(n, function () { setTimeout(sync, 0); });
    });
    BS.onDomAdded(sync, 100);
  });
  /* BEDSTU END: cart */

  /* BEDSTU START: sitewide */
  BS.register('sitewide', true, function (BS) {
    var cfg = BS.cfg;

    // AfterShip returns page: strip Klaviyo overlay + body scroll lock (5.7 custom.js 246-319).
    if (cfg.aftershipCleanup && window.location.pathname.indexOf('/apps/aftership-returns-center') !== -1) {
      var cleanup = function () {
        document.body.classList.remove('klaviyo-prevent-body-scrolling');
        document.querySelectorAll('body > div .needsclick').forEach(function (el) { el.remove(); });
      };
      cleanup();
      [500, 1500, 3000].forEach(function (ms) { setTimeout(cleanup, ms); });
      var mo = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var m = mutations[i];
          if (m.type === 'attributes' && m.target === document.body && document.body.classList.contains('klaviyo-prevent-body-scrolling')) {
            document.body.classList.remove('klaviyo-prevent-body-scrolling');
          }
          if (m.type === 'childList') {
            m.addedNodes.forEach(function (n) { if (n.nodeType === 1) n.querySelectorAll('.needsclick').forEach(function (el) { el.remove(); }); });
          }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      setTimeout(function () { mo.disconnect(); }, 30000);
    }

    if (cfg.repairScroll) {
      // Repair page CTAs → smooth scroll to the Monday.com form (#the-form).
      if (document.querySelector('.repair-program-page')) {
        var target = document.getElementById('the-form');
        var scrollTarget = target && target.parentElement && target.parentElement.parentElement ? target.parentElement.parentElement : target;
        document.querySelectorAll('.image-with-text__items .btn, .text-section .text__button .btn, .image-with-text .btn').forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            if (!scrollTarget) return;
            e.preventDefault();
            scrollTarget.scrollIntoView({ behavior: 'smooth' });
          });
        });
      }
      // Look section: reserve space for the text block on mobile.
      var padLooks = function () {
        document.querySelectorAll('.look').forEach(function (look) {
          var wrap = look.querySelector('.look__wrapper'), text = look.querySelector('.look__text');
          if (!wrap || !text) return;
          wrap.style.paddingTop = window.innerWidth < 768 ? (text.clientHeight + 30) + 'px' : '';
        });
      };
      if (document.querySelector('.look')) { padLooks(); window.addEventListener('resize', BS.debounce(padLooks, 100)); }
    }
  });
  /* BEDSTU END: sitewide */

  /* BEDSTU START: shop-pay-terms-below
     Client: the Shop Pay installments line goes between "Buy with Shop" and Shopify's
     "Arrives ... Promise" box. buy-buttons.liquid renders it under the buttons (same fence);
     Shopify's script draws the Shop button, the Promise box and "More payment options" later,
     as children of <shopify-accelerated-checkout> shown through named slots. Giving the line
     slot="promise" and putting it right before the Promise box shows it in that spot. It stays
     inside the product form, so Shopify still updates the amount per variant. No Promise box
     (or no Shop button): the line stays under the buttons. */
  BS.register('shop-pay-terms', true, function () {
    function place() {
      document.querySelectorAll('form[data-product-form]').forEach(function (form) {
        var terms = form.querySelector('.shop-pay-terms--below');
        if (!terms) return;
        var ac = form.querySelector('shopify-accelerated-checkout');
        var promise = ac && ac.querySelector(':scope > [slot="promise"]:not(.shop-pay-terms--below)');
        if (promise) {
          if (promise.previousElementSibling !== terms) {
            terms.setAttribute('slot', 'promise');
            promise.before(terms);
          }
        } else if (terms.hasAttribute('slot')) {
          terms.removeAttribute('slot');
          var holder = form.querySelector('.product__submit__holder');
          if (holder) holder.after(terms);
        }
      });
    }
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; place(); });
    }).observe(document.body, { childList: true, subtree: true });
    place();
  });
  /* BEDSTU END: shop-pay-terms-below */

  /* BEDSTU END: modules */

  function boot() {
    BS.modules.forEach(function (m) {
      if (!m.enabled) return;
      try { m.init(BS); } catch (e) { if (window.console) console.error('[bedstu] ' + m.name, e); }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
